import zod from 'zod';
import { stringToBoolean, stringToListOfNumber, zodLimit, zodPage } from './helpers';
import { cameraTypes } from './cameras';

export const manufacturers = [
    'hikvision',
    'dahua',
    'intelbras'
] as const;
export type Manufacturer = typeof manufacturers[number];

export const ManagementSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    offline: stringToBoolean.optional(),
    tagsIds: stringToListOfNumber.optional(),
    type: zod.enum(cameraTypes).optional(),
    manufacturer: zod.enum(manufacturers).optional(),
    installationCompanyId: zod.coerce.number().optional(),
    internetCompanyId: zod.coerce.number().optional(),
    hasFacial: stringToBoolean.optional(),
    hasLpr: stringToBoolean.optional(),
    hasAreaInvasion: stringToBoolean.optional()
});
